/**
 * The alert rows' rules (Phase 10 plan §4.5): which alert a row may open, and
 * until when. How loud its mark is lives in `tone.ts`. Plain TypeScript; `AlertRows.svelte` draws it.
 */

import { CAP_ID_RE } from '../deeplink'

/**
 * The CAP id a row opens, or null when it cannot be trusted.
 *
 * The bundle's `Alert.id` is NWS's **URL** for the alert
 * (`https://api.weather.gov/alerts/urn:oid:…`), not a CAP id. The id is the
 * last path segment, and it is validated against the backend's `CAP_ID_RE`
 * before it goes anywhere, the rule for every id that arrives from a third
 * party. A row whose id fails renders no button at all.
 */
export function capIdOf(id: string | null | undefined): string | null {
  if (!id) return null
  const last = id.split('/').pop() ?? ''
  let decoded: string
  try {
    decoded = decodeURIComponent(last)
  } catch {
    return null
  }
  return CAP_ID_RE.test(decoded) ? decoded : null
}

/**
 * "Until 9:30 PM" today, "Until Tue 9:30 PM" on another day, in the viewer's
 * zone like every other alert time in the app. Empty with no expiry.
 */
export function untilLabel(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return ''
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return ''
  const d = new Date(t)
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  if (d.toDateString() === now.toDateString()) return `Until ${time}`
  return `Until ${d.toLocaleDateString([], { weekday: 'short' })} ${time}`
}
